<script setup lang="ts">
import {ref} from 'vue'
import Translator from "@/utils/common/Translator.ts";
import NamaIcon from "@/components/icons/NamaIcon.vue";
import MyProfile from "@/components/settings/MyProfile.vue";
import Preferences from "@/components/settings/Preferences.vue";
import About from "@/components/settings/About.vue";
import ResetPassword from "@/components/settings/ResetPassword.vue";
import {Screen} from "quasar";
import EditContactInfo from "@/components/settings/EditContactInfo.vue";
import {storeToRefs} from "pinia";
import {useNamaFlagsStore} from "@/stores/nama-flags-store.ts";

defineProps<{ isInDialog?: boolean }>();

const {darkMode} = storeToRefs(useNamaFlagsStore());
const tab = ref('myProfile');
const pages = [
  {
    name: 'myProfile',
    icon: 'nm-user',
    component: MyProfile
  }, {
    name: 'editContactInfo',
    icon: 'nm-email_4548492',
    component: EditContactInfo
  }, {
    name: 'resetPassword',
    icon: 'security',
    component: ResetPassword
  },
  {
    name: 'GUIPreferences',
    icon: 'settings_suggest',
    component: Preferences
  },
  {
    name: 'about',
    icon: 'info',
    component: About
  },
]
</script>

<template>
  <div class="tw-h-full tw-relative tw-w-full tw-flex tw-flex-col tw-p-5 mobile:tw-p-3">
    <div class="tw-h-full tw-w-full tw-flex tw-flex-col">
      <div v-if="!isInDialog"
        class="tw-flex tw-ps-3 tw-items-center tw-gap-2  tw-text-gray-600 dark:tw-text-gray-200 tw-text-xl tw-font-bold tw-pb-3 mobile:tw-pb-2">
        <div class="tw-shrink-0 tw-flex tw-items-center tw-gap-1">
          <span v-text="Translator.translateId('settings')"/>
        </div>
      </div>
      <q-card class="tw-h-full tw-w-full tw-flex tw-flex-col tw-shadow-none tw-bg-transparent tw-rounded-lg">
        <div
          class="tw-flex tw-flex-row mobile:tw-flex-col tw-w-full tw-h-full tw-top-0 tw-rounded-b-lg tw-bg-namaBackground-deep-light dark:tw-bg-namaBackground-deep-dark tw-pb-0">
          <q-tabs
            v-model="tab"
            :vertical="!Screen.lt.sm"
            indicator-color="primary"
            align="left"
            :no-caps="true"
            class="tw-w-fit mobile:tw-w-full mobile:tw-h-fit"
          >
            <q-tab v-for="(page, pageIndex) in pages" :key="pageIndex" :name="page.name" class="tw-w-full tw-justify-start">
              <template #default>
                <div class="tw-px-4 tw-py-3 tw-w-full tw-flex tw-items-center tw-justify-between">
                  <NamaIcon :defaultIcon="page.icon" class="tw-size-5"/>
                  <span v-text="Translator.translateId(page.name)"
                        class="tw-text-base tw-text-namaFontColor-darkGray dark:tw-text-namaFontColor-dark tw-pl-2"/>
                </div>
              </template>
            </q-tab>
          </q-tabs>
          <q-tab-panels
            v-model="tab"
            animated
            swipeable
            :vertical="!Screen.lt.sm"
            transition-prev="jump-up"
            transition-next="jump-up"
            class="tw-grow tw-bg-transparent tw-rounded-lg"
          >
            <q-tab-panel v-for="(page, pageIndex) in pages" :key="pageIndex" :name="page.name"
                         class="tw-h-full tw-w-full tw-p-0">
              <q-scroll-area :dark="darkMode" class="tw-h-full tw-w-full dir-ltr tw-pt-4">
                <div :dir="Translator.fetchDir()">
                  <component :is="page.component" class="tw-h-[95%]"/>
                </div>
              </q-scroll-area>
            </q-tab-panel>
          </q-tab-panels>
        </div>
      </q-card>
    </div>
  </div>
</template>

<style>

</style>
